import ContractorAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ContractorAdditionalFilters";

const contractorViewFiltersTemplate: ContractorAdditionalFilters = {
  countries: [],
  states: [],
  cities: [],
  titles: [],
  skills: [],
  users: [],
  minRate: "",
  maxRate: "",
};

export default contractorViewFiltersTemplate;
